<template>
  <teleport to="body">
    <div v-if="snackbar.show" class="toast snackbar fade show p-2 mt-2" :class="snackbarColor">
      <div class="toast-header bg-transparent border-0">
        <span class="me-auto font-weight-normal text-white">
          {{ snackbarTitle }}
        </span>
        <i
          class="fas fa-times text-md ms-3 cursor-pointer text-white"
          @click="closeSnackbar"
        ></i>
      </div>
    </div>
  </teleport>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "MaterialSnackbar",
  computed: {
    ...mapState("snackbar", ["snackbar"]),
    snackbarTitle() {
        return this.snackbar.title;
    },
    snackbarColor() {
      return `bg-${this.snackbar.color}`;
    }
  },
  methods: {
    ...mapActions("snackbar", ["hideSnackbar"]),
    closeSnackbar() {
      this.hideSnackbar();
    }
  },
};
</script>

<style scoped>
/* Make Snackbar fixed at the bottom right */
.snackbar {
  position: fixed;
  bottom: 24px;
  right: 24px;
  left: auto;
  padding: 14px 24px;
  z-index: 9600;
  min-width: 300px;
  max-width: 600px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
}

/* Adjust right margin for smaller screens */
@media (max-width: 768px) {
  .snackbar {
    right: 12px;
    left: auto;
    min-width: auto;
    width: calc(100% - 24px);
  }
}

/* Fade-in and out animation */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>